export default __webpack_public_path__ + "static/media/Insurance_image.b10867c7.svg";